import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ViewLocation from './pages/ViewLocation';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/:code" element={<ViewLocation />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
